import SaleAnalyticsTab from './SaleAnalyticsTab'
import { withSaleAnalyticsTab } from './withSaleAnalyticsTab'

const ConnectedSaleAnalyticsTab = withSaleAnalyticsTab(SaleAnalyticsTab)

export { ConnectedSaleAnalyticsTab as SaleAnalyticsTab }
